import { useLazyQuery, useQuery } from "@apollo/client";
import { ORDER } from "../order.queries";
import { OrderQuery, OrderQueryVariables } from "../../../__generated__/OrderQuery";

export const useOrder = (id: number) => {
  return useQuery<OrderQuery, OrderQueryVariables>(ORDER, { variables: { id } });
};

export const useLazyOrder = () => {
  return useLazyQuery<OrderQuery, OrderQueryVariables>(ORDER);
};
